module.exports = __webpack_public_path__ + "img/gb-ork.b62cd4cf.svg";